import { FaCircleCheck } from "react-icons/fa6"
import { Box, Center, VStack } from "@chakra-ui/react"
import { Text } from "@/components"

interface Props {
  complianceType: string
}

export const PendingDocumentComponent = ({ complianceType }: Props) => {
  return (
    <Center w="100%" h="100%">
      <VStack position="relative" zIndex={1} w="40%" p={5} borderRadius={10} bg="card.bg" boxShadow="md" mt={20} >
        <Box borderRadius={5} bg="green.300" p={3}>
          <FaCircleCheck size={30} color="white" />
        </Box>
        <Text fontSize="lg" fontWeight="bold" textAlign="center" mt={2} mb={2}>
          Thank You!
        </Text>
        <Text fontSize="sm" textAlign="center" mb={5}>
          Thank you for signing our {complianceType}. Please check your email for a DocuSign link sent from docusign@esofund.com which you and your Equity Partner will sign.
        </Text>
        <Text fontSize="sm" textAlign="center">If you didn't receive an email please contact your Equity Partner.</Text>
      </VStack>
    </Center>
  )
}
